const termsOfUse = {
  content: `<v-layout row wrap>
  <v-flex xs12>
    <b></b>
    <p class="body-1" style="text-align: justify">
      Los presentes términos y
      <b>condiciones de Uso, y Política de Privacidad</b>, regulan el
      uso del,
      <b>SITIO WEB:</b>
      <a href="https://www.fbase.tv" target="_blank">
        <u>http://www.fbase.tv</u>
      </a> , de la que,
      <b>GLOSPEN, SL</b>, con
      <b>NIF: L-713690W</b>, con Domicilio en:
      <b>CTRA. DE LA PLANA, EDIF. MIRADOR PARC, B-II, 5º 2ª</b>, Código Postal:
      <b>AD700</b>. Localidad:
      <b>ESCALDES-ENGORDANY, ANDORRA</b>, es
      titular.
    </p>
    <p class="body-1" style="text-align: justify">
      A través de su
      <b>SITIO WEB</b>,
      <a href="https://www.fbase.tv" target="_blank">
        <u>http://www.fbase.tv</u>
      </a> , de,
      <b>GLOSPEN, SL</b>, en adelante, el
      administrador de la página web. Debido al contenido y la finalidad del
      <b>SITIO WEB</b>, las
      personas que quieran información o compra de nuestros partidos, deberán registrarse
      en el formulario de,
      <b>USUARIOS/CLIENTES</b>, el cual se adquiere completando el
      formulario de
      <b>REGISTRO</b>, sus datos serán incorporados en un fichero automatizado,
      según lo expuesto en el artículo, 13, del Reglamento General de Protección de Datos-
      UE-2016/679, del Parlamento y Consejo de Europa, del, 27 de abril de 2016, por la
      Ley Orgánica 3/2018, de Protección de Datos Personales y garantías de los derechos
      Digitales y la aplicación de la Directiva 2011/83/UE de 25 de octubre, sobre los
      derechos de los consumidores.
    </p>

    <ol style="text-align: justify" class="mb-3">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>INFORMACIÓN SOBRE LA WEB</u>
        </li>
        <p class="body-1">
          El
          <b>SITIO WEB:</b>
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , de la que es Administrador,
          <b>GLOSPEN, SL</b>, de
          la plataforma
          <b>fbase.tv</b>, para la emisión de partidos de futbol de distintas categorías en
          directo, indeferido o la visión de videos de los propios jugadores para su promoción.
        </p>
      </div>
      <div>
        <p class="body-2 font-weight-bold">
          <u>PUBLICIDAD</u>
        </p>
        <p class="body-1">
          La Web:
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , podrá albergar contenidos publicitarios o
          patrocinados. Los anunciantes o patrocinadores son los únicos responsables de
          asegurarse que el material remitido para su inclusión en la Web cumple con las leyes
          que en cada caso puedan ser de aplicación.
          <b>GLOSPEN, SL</b> no será responsable de
          cualquier error, inexactitud o irregularidad que puedan contener los contenidos
          publicitarios o de los patrocinadores.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>DISPONIBILIDAD</u>
        </li>
        <p class="body-1">
          El administrador de la página web hará todo lo posible para resolver todas las dudas y
          gestiones solicitadas a todos sus
          <b>USUARIOS/CLIENTES</b>, a la mayor brevedad posible
          en la demanda de las consultas.
        </p>
        <p class="body-1">
          Sin embargo, en ocasiones, y por causas difícilmente controlables por el administrador
          de la página web como errores humanos o incidencias en los sistemas informáticos, es
          posible que la rapidez finalmente servida a los
          <b>USUARIOS/CLIENTES</b>, difiera del pedidos de los
          <b>USUARIOS/CLIENTES</b>.
        </p>
        <p class="body-1">
          Para el caso de que la gestión no esté disponible o no se pudiera llegar a finalizar,
          después de haber realizado la reserva, el
          <b>USUARIO/CLIENTE</b>, será informado por
          correo electrónico de la anulación total de éste.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>SEGURIDAD</u>
        </li>
        <p class="body-1">
          El administrador de la página web tiene las máximas medidas de seguridad
          comercialmente disponibles en el sector. Además, el proceso de pago funciona sobre
          un servidor seguro utilizando el protocolo SSL. El servidor seguro establece una
          conexión de modo que la información se transmite cifrada mediante algoritmos de 128
          bits, que aseguran que sólo sea inteligible y comprensible por el ordenador del
          <b>USUARIO/CLIENTE</b>, y el del
          <b>SITIO WEB</b>, de esta forma, al utilizar el protocolo SSL se
          garantiza:
        </p>
        <ol class="mb-3">
          <li>
            Que el
            <b>USUARIO/CLIENTE</b>, está comunicando sus datos al centro servidor del
            administrador de la página web y no a cualquier otro que intentara hacerse pasar por
            éste.
          </li>
          <li>
            Que entre el
            <b>USUARIO/CLIENTE</b>, y el centro servidor del administrador de la
            página web los datos se transmiten cifrados, evitando su posible lectura o
            manipulación por terceros.
          </li>
        </ol>
        <p class="text-xs-center body-2 font-weight-bold">
          <u>CERTIFICADOS DE CUMPLIMIENTO LSSI-CE Y PROTECCIÓN DE DATOS</u>
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b>, de la que es titular del sitio web,
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , cumple con la
          normativa de Protección de Datos Europea vigente y con la LSSI-CE, y es asesorada
          en estas normativas por GRUPO QUALIA , por lo que se le otorgan sendos
          certificados en formato de imagen digital para que pueda exponerlos en su sitio web.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PROPIEDAD INTELECTUAL E INDUSTRIAL</u>
        </li>
        <p class="body-1">
          El administrador de la página web tiene todos los derechos sobre el contenido, diseño
          y código fuente de esta página web,
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , y, en especial, con carácter
          enunciativo pero no limitativo, sobre las fotografías, imágenes, textos, logos, diseños,
          marcas, nombres comerciales y datos que se incluyen en la web.
        </p>
        <p class="body-1">
          Se advierte a
          <b>USUARIOS/CLIENTES</b>, que estos derechos están protegidos por la
          legislación vigente Europea e internacional relativa a la propiedad intelectual e
          industrial. Asimismo, y sin perjuicio de lo anterior, el contenido del
          <b>SITIO WEB</b>,
          también tiene la consideración de programa informático, y por lo tanto, le resulta
          también de aplicación toda la normativa comunitaria europea vigente en la materia.
        </p>
        <p class="body-1">
          Queda expresamente prohibida la reproducción total o parcial de esta web, ni de
          cualquiera de sus contenidos, sin el permiso expreso y por escrito del administrador de
          la página web.
        </p>
        <p class="body-1">
          Asimismo queda totalmente prohibida la copia, reproducción, adaptación, modificación,
          distribución, comercialización, comunicación pública y/o cualquier otra acción que
          comporte una infracción de la normativa vigente en materia de propiedad intelectual
          y/o industrial, así como el uso de los contenidos de la web si no es con la previa
          autorización expresa y por escrito del administrador.
        </p>
        <p class="body-1">
          El administrador de la página web informa que no concede licencia o autorización
          implícita sobre los derechos de propiedad intelectual y/o industrial o sobre cualquier
          otro derecho o propiedad relacionada, directa o indirectamente, con los contenidos
          incluidos en el
          <b>SITIO WEB</b>:
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a>
        </p>
        <p class="body-1">
          Sólo se autoriza la utilización de los contenidos del dominio web con fines informativos
          y de servicio, siempre que se cite o se haga referencia a la fuente, siendo el usuario el
          único responsable del mal uso de los mismos.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>ACCESO Y ESTANCIA EN LA WEB</u>
        </li>
        <p class="body-2 font-weight-bold">
          <u>NUESTROS CONTENIDOS</u>
        </p>

        <p class="body-1">
          Los USUARIO/CLIENTES, son íntegramente responsables de su conducta, al acceder
          a la información del
          <b>SITIO WEB</b>, mientras naveguen en la misma, así como después
          de haber accedido.
        </p>
        <p class="body-1">
          Como consecuencia de ello, los
          <b>USUARIOS/CLIENTES</b>, son los únicos responsables
          ante el administrador de la página web y terceros de:
        </p>

        <ol>
          <li class="mb-2">
            Las consecuencias que se puedan derivar de una utilización, con fines o efectos
            ilícitos o contrarios al presente documento, de cualquier contenido del
            <b>SITIO WEB</b>,
            elaborado o no por el administrador de la página web, publicado o no bajo su
            nombre de forma oficial.
          </li>
          <li class="mb-2">
            Así como de las consecuencias que se puedan derivar de la utilización contraria al
            contenido del presente documento y lesiva de los intereses o derechos de
            terceros, o que de cualquier forma pueda dañar, inutilizar o deteriorar el SITIO
            WEB, o sus servicios o impedir el normal disfrute por otros usuarios.
          </li>
        </ol>
        <p class="body-1">
          El administrador de la página web se reserva el derecho a actualizar los contenidos
          cuando lo considere conveniente, así como eliminarlos, limitarlos o impedir el acceso a
          ellos, de manera temporal o definitiva, así como denegar el acceso al
          <b>SITIO WEB</b> a
          <b>USUARIOS/CLIENTES</b>, que haga un mal uso de los contenidos y/o incumplan
          cualquiera de los términos y condiciones que aparecen en el presente documento.
        </p>
        <p class="body-1">El administrador de la página web informa que no garantiza:</p>
        <ol>
          <li class="mb-2">
            Que el acceso al
            <b>SITIO WEB</b>, y/o a las web de enlace sea ininterrumpido o libre de
            error.
          </li>
          <li class="mb-2">
            Que el contenido o software al que los
            <b>USUARIOS/CLIENTES</b>, accedan a través de
            la web o de las web de enlace no contenga ningún error, virus informático u otros
            elementos en los contenidos que puedan producir alteraciones en su sistema o en los
            documentos electrónicos y ficheros almacenados en su sistema informático o cause
            otro tipo de daño.
          </li>
          <li class="mb-2">
            El aprovechamiento que de la información o contenido del
            <b>SITIO WEB</b>, o webs de
            enlace que los
            <b>USUARIOS/CLIENTES</b>, pudieran hacer para sus propósitos
            personales.
          </li>
        </ol>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>NUESTRA RESPONSABILIDAD</u>
        </li>
        <p class="body-1">
          El administrador de la página web no asume ninguna responsabilidad derivada, a título
          enunciativo pero no limitativo:
        </p>
        <p class="body-1">
          De la utilización que los
          <b>USUARIOS/CLIENTES</b>, puedan hacer de los materiales del
          <b>SITIO WEB</b> o webs de enlace, ya sean prohibidos o permitidos, en infracción de los
          derechos de propiedad intelectual y/o industrial de contenidos del
          <b>SITIO WEB</b>, o de
          terceros.
        </p>
        <p class="body-1">
          Los eventuales daños y perjuicios a los
          <b>USUARIOS/CLIENTES</b>, causados por un
          funcionamiento normal o anormal de las herramientas de búsqueda, de la organización
          o la localización de los contenidos y/o acceso al
          <b>SITIO WEB</b>, y, en general, los errores
          o problemas que se generen en el desarrollo o instrumentación de los elementos
          técnicos que el
          <b>SITIO WEB</b>, o un programa facilite el
          <b>USUARIO/CLIENTE</b>.
        </p>
        <p class="body-1">
          De los contenidos de aquellas páginas a las que los
          <b>USUARIOS/CLIENTES</b>, puedan
          acceder desde enlaces incluidos en el
          <b>SITIO WEB</b>, ya sean autorizados o no.
        </p>
        <p class="body-1">
          Los actos u omisiones de terceros, con independencia de que estos terceros pudiesen
          estar unidos al administrador de la página web mediante vía contractual.
        </p>
        <p class="body-1">
          Del acceso de menores de edad a los contenidos incluidos en el
          <b>SITIO WEB</b>, siendo
          responsabilidad de sus progenitores o tutores ejercer un control adecuado sobre la
          actividad de los hijos o menores a su cargo o bien instalar alguna de las herramientas
          de control del uso de Internet con el objeto de evitar el acceso a materiales o
          contenidos no aptos para menores, así como el envío de datos personales sin la
          previa autorización de sus progenitores o tutor.
        </p>
        <p class="body-1">
          El administrador de la página web no será responsable en ningún caso cuando se
          produzcan:
        </p>
        <ul>
          <li class="mb-2">
            Errores o retrasos en el acceso al
            <b>SITIO WEB</b>, por parte del
            <b>USUARIO/CLIENTE</b>, a la hora de introducir sus datos en el formulario de
            pedido de servicios, la lentitud o imposibilidad de recepción por parte de los
            destinatarios de la confirmación del pedido o cualquier anomalía que pueda
            surgir cuando estas incidencias sean debidas a problemas en la red Internet,
            causas de caso fortuito o fuerza mayor y cualquier otra contingencia
            imprevisible ajena a la buena fe del administrador de la página web.
          </li>
          <li class="mb-2">
            Errores o incidencias que pudieran producirse en las comunicaciones, borrado
            o transmisiones incompletas, de manera que no se garantiza que los servicios
            del sitio web estén constantemente operativos.
          </li>
          <li class="mb-2">
            De la no operatividad o problemas en la dirección electrónica facilitada por el
            <b>USUARIO/CLIENTE</b>, para el envío de la confirmación del pedido de servicios.
          </li>
        </ul>
        <p class="body-1">
          En todo caso, el administrador de la página web se compromete a solucionar los
          problemas que puedan surgir y a ofrecer todo el apoyo necesario al
          <b>USUARIO/CLIENTE</b>, para llegar a una solución rápida y satisfactoria de la incidencia.
        </p>
        <p class="body-1">
          Asimismo, el administrador de la página web tiene derecho a realizar durante
          intervalos temporales definidos, campañas promocionales para promover el registro de
          nuevos miembros en su servicio.
        </p>
        <p class="body-1">
          El administrador de la página web se reserva el derecho de modificar las condiciones
          de aplicación de la promociones, prorrogar comunicando debidamente, o proceder a la
          exclusión de cualquiera de los
          <b>USUARIOS/CLIENTES</b>, de la promoción en el supuesto
          de detectar cualquier anomalía, abuso o comportamiento poco ético en la participación
          de los mismos.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>POLÍTICA DE PRIVACIDAD</u>
        </li>
        <p class="body-1">
          Los
          <b>USUARIOS/CLIENTES</b> se comprometen a navegar por el
          <b>SITIO WEB</b> y a utilizar
          el contenido de buena fe.
        </p>
        <p class="body-1">
          En cumplimiento de lo establecido en el Reglamento General de Protección de Datos-
          UE-2016/679, y la LOPD-3/2018 de garantía de los derechos digitales, le informamos
          de que la cumplimentación de cualquier formulario existente en el
          <b>SITIO WEB</b>,
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , o la remisión de un correo electrónico a cualquiera de nuestros
          buzones implica la aceptación de esta política de privacidad, así como la autorización
          al administrador de la página web para que trate los datos personales que nos facilite,
          que serán incorporados al fichero, titularidad del Responsable del Tratamiento y/o
          administrador de la página web.
        </p>
        <p class="body-1">
          Los datos de los
          <b>USUARIOS/CLIENTES</b>, serán utilizados para el envío a través de
          correo electrónico de las gestiones online, que realice el administrador de la página
          web.
        </p>
        <p class="body-1">
          Por la mera visita al
          <b>SITIO WEB</b>, los
          <b>USUARIOS/CLIENTES</b>, no facilitan información
          personal ni está obligado a facilitarla.
        </p>
        <p class="body-1">
          El administrador de la página web se compromete a guardar la máxima reserva y
          confidencialidad sobre la información que le sea facilitada y a utilizarla únicamente
          para los fines indicados.
        </p>
        <p class="body-1">
          El administrador de la página web presume que los datos han sido introducidos por su
          titular o por persona autorizada por éste, así como que son correctos y exactos.
        </p>
        <p class="body-1">
          Estos datos, serán introducidos en un fichero automatizado bajo la responsabilidad del
          administrador de la web de
          <b>GLOSPEN, SL</b>, con la finalidad de poder facilitar, agilizar y
          cumplir los compromisos establecidos entre ambas partes.
        </p>
        <p class="body-1">
          Asimismo,
          <b>GLOSPEN, SL</b>, informa de la posibilidad de ejercer los derechos de
          <b>acceso</b>, que permite al usuario web, conocer que datos personales tiene el
          administrador de esta página y en tal caso contestara en un plazo de 30 días, siempre
          que conserve los datos,
          <b>rectificación</b>, que permite corregir errores, modificar los datos
          que sean inexactos o incompletos y garantizar la certeza de la información,
          <b>oposición</b>
          que podrá solicitar y conseguir que no lleve a cabo el tratamiento de datos,
          <b>supresión</b>
          que permite que se supriman los datos inadecuados o excesivos,
          <b>limitación</b>, por el
          que puede solicitar que se limite el tratamiento de sus datos cuando haya ejercido su
          derecho a la rectificación de sus datos personales, y
          <b>portabilidad</b>, para que el usuario
          pueda obtener una copia de los datos personales que haya facilitado en la web a fin de
          poder transmitirlos a otros servicios, estos derechos se podrán ejercer por cualquier
          medio que deje constancia de su envío y de su recepción a la dirección:
          <b>CTRA. DE LA PLANA, EDIF. MIRADOR PARC, B-II, 5º 2ª</b>, Código Postal:
          <b>AD700</b>, Localidad:
          <b>ESCALDES-ENGORDANY, PRINCIPAT D’ANDORRA</b>, Correo electrónico:
          <b>
            <u>Info@fbase.tv</u>
          </b>, aportando fotocopia del DNI o documentación alternativa que acredite
          su identidad.
        </p>
        <p class="body-1">
          Mientras no nos comunique lo contrario, entenderemos que sus datos no han sido
          modificados, que usted se compromete a notificarnos cualquier variación y que
          tenemos el consentimiento para utilizarlos a fin de poder fidelizar la relación entre las
          partes.
        </p>
        <p class="body-1">
          El envío de sus datos mediante el/los formularios de nuestra web estará supeditado
          obligatoriamente a que haya leído/aceptado las Condiciones de uso , mediante un
          check box obligatorio al pie del formulario.
        </p>
        <p class="body-1">
          De acuerdo con lo establecido en la Ley 34/2002, de Servicios de la Sociedad de la
          Información y el Comercio Electrónico en su artículo 21, pedimos su consentimiento
          para poder realizar comunicaciones publicitarias que consideremos puedan ser de su
          interés, por correo electrónico o por cualquier otro medio de comunicación electrónica
          equivalente, este consentimiento lo aceptará o negará con un check box obligatorio al
          pie del formulario.
        </p>
        <p class="body-1">
          Para
          <b>modificar</b>,
          <b>actualizar</b> o
          <b>cancelar</b> sus datos personales el
          <b>USUARIO/CLIENTE</b>,
          escribirá desde el correo electrónico de su cuenta a:
          <b>
            <u>Info@fbase.tv</u>
          </b>, con el asunto.
        </p>
        <p class="body-1">
          Por lo tanto, el
          <b>USUARIO/CLIENTE</b> es responsable de la veracidad de los datos y el
          administrador de la página web no será responsable de la inexactitud de los datos
          personales de los
          <b>USUARIOS/CLIENTES</b>.
        </p>
        <p class="body-1">
          De acuerdo con la legislación vigente en materia de protección de datos, el
          administrador de la página web ha adoptado los niveles de seguridad adecuados a los
          datos facilitados por los
          <b>USUARIOS/CLIENTES</b> y, además, ha instalado todos los
          medios y medidas a su alcance para evitar la pérdida, mal uso, alteración, acceso no
          autorizado y extracción de los mismos.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>NULIDAD</u>
        </li>
        <p class="body-1">
          En caso de que cualquier cláusula de los presentes términos y condiciones de uso sea
          declarada nula, el resto de cláusulas se mantendrán vigentes y se interpretarán
          teniendo en cuenta la voluntad de las partes y la finalidad misma de los presentes
          términos y condiciones.
        </p>
        <p class="body-1">
          El administrador de la página web podrá no ejercitar alguno de los derechos y
          facultades conferidos en este documento lo que no implicará en ningún caso la
          renuncia a los mismos salvo reconocimiento expreso por parte del administrador de la
          página web o prescripción de la acción que en cada caso corresponda.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>MODIFICACIÓN DE LOS TÉRMINOS Y CONDICIONES DE USO</u>
        </li>
        <p class="body-1">
          El administrador de la página web se reserva el derecho a modificar, en cualquier
          momento, la presentación y configuración del
          <b>SITIO WEB</b>, así como los presentes
          términos y condiciones de uso.
        </p>
        <p class="body-1">
          Por ello, el administrador de la página web recomienda al
          <b>USUARIO/CLIENTE</b> leer
          atentamente las condiciones y términos de uso, cada vez que acceda al
          <b>SITIO WEB</b>.
          Los
          <b>USUARIOS/CLIENTES</b>, siempre dispondrán de estos términos y condiciones de
          uso en un lugar visible, libremente accesible para cuantas consultas quiera realizar.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>LEY APLICABLE Y ARBITRAJE</u>
        </li>
        <p class="body-1">
          Los presentes términos y condiciones de uso se rigen por la legislación española
          aplicable en la materia. Para resolver cualquier controversia o conflicto que se derive,
          las partes se someten a la jurisdicción de los tribunales del
          <b>partido judicial</b> de,
          <b>ESCALDES-ENGORDANY, PRINCIPAT D’ANDORRA</b>, de la ciudad origen de la
          empresa propietaria del
          <b>SITIO WEB</b> salvo que la ley imponga otra jurisdicción.
        </p>
        <p class="body-1">
          Por ello, el administrador de la página web recomienda al
          <b>USUARIO/CLIENTE</b> leer
          atentamente las condiciones y términos de uso, cada vez que acceda al
          <b>SITIO WEB</b>.
          Los
          <b>USUARIOS/CLIENTES</b>, siempre dispondrán de estos términos y condiciones de
          uso en un lugar visible, libremente accesible para cuantas consultas quiera realizar.
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
}
export default termsOfUse
